module.exports = __webpack_public_path__ + "static/img/jiazai.2457aabb.png";